import axios from 'axios'

const translate = (
  apiGoogleTranslateUrl,
  apiGoogleTranslateKey,
  textToTranslate,
  sourceLang,
  targetLang
) => new Promise((resolve, reject) => {
  try {
    var accessUrl = apiGoogleTranslateUrl + '?key=' + apiGoogleTranslateKey
    accessUrl += '&q=' + encodeURI(textToTranslate)
    accessUrl += '&source=' + sourceLang.substr(0, 2)
    accessUrl += '&target=' + targetLang.substr(0, 2)

    resolve(
      axios({
        method: 'GET',
        url: accessUrl,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          var tmp = document.createElement('div')
          tmp.innerHTML = decodeURI(response.data.data.translations[0].translatedText)
          return {
            textToTranslate: textToTranslate,
            sourceLang: sourceLang,
            targetLang: targetLang,
            translatedText: tmp.textContent || tmp.innerText || ''
          }
        })
    )
  } catch (err) {
    reject(new Error(err))
  }
})

export default translate
